module.exports = __webpack_public_path__ + "img/jgdy-logo.ff361a1b.png";